<template>
    <div class="user">
        <div class="common-level-rail">
            <el-button size="small" type="info" icon="el-icon-back" @click="$router.back()">返回</el-button>
            <el-button size="small" type="primary" icon="el-icon-plus" @click="openGoods">添加商品</el-button>
        </div>

        <div class="goods-content">
            <el-form ref="form" :model="form" label-width="100px">
                <div class="table-wrap">
                    <el-table v-loading="loading" size="small" :data="tableData" border style="width: 100%">
                        <el-table-column prop="goods_name" label="商品名称" width="360">
                            <template slot-scope="scope">
                                <div class="goods-info">
                                    <div class="pic" style="width: 40px; height: 40px;"><img v-img-url="scope.row.goods.image[0].file_path" alt=""/></div>
                                    <div class="info">
                                        <div class="name">{{ scope.row.goods.goods_name }}</div>
                                    </div>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="is_recommend" label="是否推荐">
                            <template slot-scope="scope">
                                <div v-if="scope.row.is_recommend == 1" class="green">是</div>
                                <div v-else class="gray3">否</div>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="image_id" label="推荐图片" width="180">
                            <template slot-scope="scope">
                                <div v-if="scope.row.image != null && scope.row.is_recommend == 1">
                                    <img v-img-url="scope.row.image.file_path" style="width: 30px; height: 30px;" alt="" />
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="create_time" label="申请时间"></el-table-column>
                        <el-table-column prop="sort" label="排序" width="120">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.sort" size="mini" @change="changeSort($event,scope.row)"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="220">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" v-if="scope.row.is_recommend == 1" @click="editImg(scope.row)">推荐图片</el-button>
                                <el-button type="text" size="small" @click="batchItem(scope.row)">批次设置</el-button>
                                <el-button type="text" size="small" @click="recommendItem(scope.row, scope.$index)" v-loading="recommendLoadingMap[scope.$index]">{{scope.row.is_recommend ? '取消推荐' : '推荐'}}</el-button>
                                <el-button type="text" size="small" @click="delClick(scope.row)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
            <!--分页-->
            <div class="pagination">
                <el-pagination
                    background
                    :current-page="curPage"
                    :page-size="pageSize"
                    layout="total, prev, pager, next, jumper"
                    :total="totalDataNumber"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                ></el-pagination>
            </div>
        </div>
        <!--商品选择-->
        <Goods :isgoods="isgoods" :exclude-ids="exclude_ids" :islist="false" @closeDialog="closeGoodsFunc"></Goods>
    </div>
</template>
<script>
    import PlatformActivityApi from "@/api/platformactivity.js";
    import Goods from "@/components/goods/Goods.vue";
    export default {
        components:{
            /*选择商品*/
            Goods
        },
        data() {
            return {
                formInline: {},
                form: {},
                tableData: [],
                pageSize: 20,
                totalDataNumber: 0,
                curPage: 1,
                /*是否加载完成*/
                loading: true,

                /*是否打开选择商品*/
                isgoods: false,
                /*已有的id*/
                exclude_ids: [],
                activity_id: 0,
                recommendLoadingMap: {},
            };
        },
        created() {
            /*获取列表*/
            this.getData();
        },
        methods: {
            /*获取列表*/
            getData() {
                let self = this;
                let Params = {};
                Params.activity_id = self.$route.query.activity_id;
                Params.page = self.curPage;
                Params.list_rows = self.pageSize;
                PlatformActivityApi.goods.list(Params, true)
                    .then((data) => {
                        self.loading = false;
                        self.tableData = data.data.list.data;
                        self.totalDataNumber = data.data.list.total;
                        self.exclude_ids = data.data.exclude_ids;

                        let recommendLoadingMap = {};
                        data.data.list.data.forEach((item, index) => {
                            recommendLoadingMap[index] = false;
                        });
                        self.recommendLoadingMap = recommendLoadingMap;
                    })
                    .catch((error) => {});
            },
            /*选择第几页*/
            handleCurrentChange(val) {
                this.curPage = val;
                this.loading = true;
                this.getData();
            },

            /*每页多少条*/
            handleSizeChange(val) {
                this.curPage = 1;
                this.getData();
            },
            /*删除*/
            delClick: function(row) {
                let self = this;
                self.$confirm("删除后不可恢复，确认删除该记录吗?", "提示", {
                    type: "warning"
                }).then(() => {
                    PlatformActivityApi.goods.delete({
                        activity_goods_id: row.activity_goods_id
                    }).then((data) => {
                        self.$message({
                            message: "删除成功",
                            type: "success"
                        });
                        self.getData();
                    });
                });
            },



            /*打开添加*/
            openGoods() {
                this.isgoods = true;
            },

            /*关闭商品选择*/
            closeGoodsFunc(e) {
                let self = this;
                this.isgoods = false;
                if (e.type == "success") {
                    PlatformActivityApi.goods.add({
                        goods_id: e.params.goods_id,
                        activity_id: self.$route.query.activity_id
                    }).then((data) => {
                        self.$message.success("添加成功");
                        self.getData();
                    })
                }
            },


            batchItem(row) {
                this.$router.push({
                    path: "/platformactivity/batch/index",
                    query: {
                        activity_id: row.activity_id,
                        goods_id: row.goods_id,
                    }
                });
            },
            recommendItem(row,index) {
                let self = this;
                self.recommendLoadingMap[index] = true;
                PlatformActivityApi.goods.recommend({
                    activity_goods_id: row.activity_goods_id,
                }).then((data) => {
                    self.recommendLoadingMap[index] = false;
                    self.tableData[index].is_recommend = !self.tableData[index].is_recommend;
                    self.$message.success("设置成功");
                    // self.getData();
                })
            },
            /*编辑推荐图片*/
            editImg(row) {
                let params = row.activity_goods_id;
                this.$router.push({
                    path: "/platformactivity/goods/edit",
                    query: {
                        activity_goods_id: params
                    }
                });
            },
            changeSort(e,item){
                let self = this;
                PlatformActivityApi.goods.changeSort({
                    activity_goods_id: item.activity_goods_id,
                    sort: e
                }).then((data) => {
                    self.$message({
                        message: "操作成功",
                        type: "success"
                    });
                    self.getData();
                });
            }

        }
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/platformactivity/goods/index.vue